<template>
  <v-container v-if="profiel">
    <h1>Details profiel</h1>
    <v-form v-model="valid" lazy-validation ref="form"></v-form>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field label="Naam" maxlength="250" required v-model="profiel.Naam"></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Dashboards in profiel</v-card-title>
          <v-card-text>
            <v-list>
              <v-list-item v-for="(p,i) in profiel.Dashboard" :key="'d'+i.toString()">
                <v-list-item-content>{{p.Naam}}</v-list-item-content>
                <v-list-item-icon>
                  <v-icon title="Dashboard instellingen" @click="instellingen(p)">mdi-cog</v-icon>
                  <v-icon title="Verwijder dashboard uit profiel" @click="deleteDashboard(p)">mdi-delete</v-icon>
                </v-list-item-icon>
              </v-list-item>
            </v-list>
            <v-select
              label="Dashboard toevoegen aan profiel"
              :items="dashboards"
              item-text="Naam"
              v-model="selectedDashboard"
              return-object
            ></v-select>
            <v-btn fab color="secondary" title="Dashboard toevoegen" @click="addDashboard()">
              <v-icon>mdi-plus-thick</v-icon>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="6">
        <InstellingenAfdelingen v-if="instellingenAfdeling">
        </InstellingenAfdelingen>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="primary" @click="save()" :disabled="!valid">
          <v-icon left>mdi-content-save-outline</v-icon>Opslaan
        </v-btn>
        <v-btn class="mx-4" @click="cancel()">
          <v-icon left>mdi-close-circle</v-icon>Annuleren
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import InstellingenAfdelingen from "@/components/administration/dashboardsettings/afdelingen.vue";

export default {
  name: "BeheerProfiel",
   components: { InstellingenAfdelingen },
  data: () => ({
    dashboards: [],
    profiel: null,
    valid: true,
    selectedDashboard: null,
    instellingenAfdeling: false,
  }),
  methods: {
    loadData: function () {
      this.$api.pProfielbeheerDashboardsGet().then((response) => {
        this.dashboards = response.data;
      });
      this.$api
        .pProfielGet({ ProfielId: this.$route.params.id })
        .then((response) => {
          this.profiel = response.data[0];
        });
    },
    save: function () {
      if (this.$refs.form.validate()) {
        this.$api.pProfielSave(this.profiel).then((response) => {
          if (response.data[0].Success) {
            this.$router.push({ name: "beheerprofielen" });
          } else {
            alert(response.data[0].Msg);
          }
        });
      }
    },
    addDashboard: function() {
      if (this.selectedDashboard)
      {
        this.profiel.Dashboard.push(this.selectedDashboard);
      }
    },
    instellingen: function(/*profiel*/)
    {
      this.instellingenAfdeling = true;
    },
    deleteDashboard: function(profiel)
    {
      if (confirm('Weet je zeker dat je dit dashboard uit het profiel wilt verwijderen?'))
      {
        let pos = this.profiel.Dashboard.indexOf(profiel);
        this.profiel.Dashboard.splice(pos, 1);
      }
    },
    cancel: function () {
      this.$router.push({ name: "beheerprofielen" });
    },
  },
  watch: {},
  mounted() {
    this.loadData();
  },
};
</script>